import * as $ from 'jquery';
import 'bootstrap';
import { mHolidays } from "../m-holidays";

export class mHolidaysIndex {
	private indxBody:any   = $('#mholidays-index-body');
	private mholidaysBase:any = new mHolidays();
}

let scope:Element = document.querySelector('#mholidays-index-body');

if (scope) {
	try {
		let mholidaysindex = new mHolidaysIndex();
		$(document).ready(function() {
			$("#searchFlightHotel").modal({backdrop:false, keyboard:false});
			$('body').addClass('mhZeroRightPad');
		});
	} catch(e) {console.error(e);}
}
